import React, { Fragment } from "react";

function AboutContentAr() {
  return (
    <Fragment>
      <section className="about_banner" dir="rtl">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <div className="col_selector text-right">
                <h2 className="Almaraibold mb-2">حول</h2>
                <p className="fz13 Almaraibold">
                    نؤمن أنه من خلال الجمع بين الجيران ، يمكننا إنشاء عالم أكثر لطفًا حيث يكون للجميع حي يمكن الاعتماد عليه. 
                </p>
              </div>
            </div>
           <div className="col-md-6"></div>
          </div>
        </div>
      </section>
      <section className="terms_condition_section about_page pb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="col_selector text-right Almaraibold">
                <h3 className="fz18 mb-4">مقدمة</h3>
                <p>حومتي هو تطبيق  تواصل اجتماعي وتجارة الكترونية يساعدك على البقاء على اتصال مع جيرانك. كبديل لوسائل التواصل الاجتماعي التقليدية ، يتيح لك تطبيق حومتي بناء علاقات أوثق مع جيرانك والبقاء على اطلاع على آخر الأخبار والصفقات في منطقتك.</p>
                <p>كما يجعل من السهل الحصول على معلومات حول الخدمات (الخاصة والعامة) و النشاطات التجارية من المصادر التي تثق بها، جيرانك من نفس الدائرة أو الدوائر المحيطة.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
}

export default AboutContentAr;
